import { empty } from 'rxjs/observable/empty';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';
export var AUTOCOMPLETE_PLUGIN_NAME = 'jql-autocomplete-plugin';
export var ARROW_UP_KEY = 'ArrowUp';
export var ARROW_DOWN_KEY = 'ArrowDown';
export var CMD_ARROW_UP_KEY = 'Cmd-ArrowUp';
export var CMD_ARROW_DOWN_KEY = 'Cmd-ArrowDown';
export var HOME_KEY = 'Home'; // === Fn-Left in Mac
export var END_KEY = 'End'; // === Fn-Right in Mac
export var ENTER_KEY = 'Enter';
export var ESCAPE_KEY = 'Escape';
export var TAB_KEY = 'Tab';

// No-op autocomplete provider used when creating the initial state
export var defaultAutocompleteProvider = {
  onFields: function onFields() {
    return empty();
  },
  onOperators: function onOperators() {
    return empty();
  },
  onValues: function onValues() {
    return empty();
  },
  onFunctions: function onFunctions() {
    return empty();
  }
};
export var JQLAutocompletePluginKey = new PluginKey(AUTOCOMPLETE_PLUGIN_NAME);